import script from "./FormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormItem.vue?vue&type=script&setup=true&lang=ts"

import "./FormItem.vue?vue&type=style&index=0&id=f0e34684&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e34684"]])

export default __exports__